<template>
  <div style="position: relative; min-height: calc(100vh - 115px)" class="bg-white p-4">
    <div class="flex">
      <div class="left" :style="{ flex:'auto',width: 'calc(100% - 290px)' }">
        <div v-if="emptyShow" class="" v-loading="tableLoading">
          <!-- <div class="no-question-component flex justify-center relative">
            <div class="">
              <div class="text-tip mt-48">分配任务后，即可开启指定样本面对面访问答题。</div>
              <div class="text-center mt-6">
                <el-button type="primary" @click="onClickAssignTask">分配任务</el-button>
              </div>
            </div>
          </div> -->
          <div class="welcome-pages-wrap" v-if="propsWelcomeShow">
            <div class="welcome-pages-center">
              <div class="welcome-title">指定样本面访</div>
              <div class="welcome-desc" v-html="'从指定样本库中随机抽取指定样本，线下开展面访<br />可应用于指定人群面访，指定地点检查等场景<br/>调查员通过“ 调研工厂调查员版 App ”开展调查，全程录音录像，支持离线调查，生成调查员调查轨迹。'"></div>
              <el-button type="primary" @click="onClickAssignTask">添加指定样本面访</el-button>
              <img class="welcome-img" src="@/assets/img/wj/assign-welcome.png" />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="flex flex-wrap mb-3">
            <el-input style="width: 128px" placeholder="调查员姓名" v-model="executorName" @keyup.enter.native="toSearch">
            </el-input>
            <el-input class="ml-3" style="width: 128px" placeholder="手机号" v-model="SearchPhoneValue" @keyup.enter.native="toSearch">
            </el-input>
            <el-input class="ml-3" style="width: 128px" placeholder="任务名称" v-model="executionName" @keyup.enter.native="toSearch">
            </el-input>
            <el-select v-model="SearchStatusValue" placeholder="任务状态" style="width: 128px" class="ml-3">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <div class="inline-block ml-3" style="width: 140px">
              <el-button class="" type="primary" @click="toSearch">
                <span class="px-0.5">查询</span>
              </el-button>
              <el-button class="ml-3" @click="onReset">
                <span class="px-0.5">重置</span>
              </el-button>
            </div>
          </div>
          <!-- <div class="welcome-pages-wrap" v-if="propsWelcomeShow">
            <div class="welcome-pages-center">
              <div class="welcome-title">指定样本面访</div>
              <div class="welcome-desc" v-html="'从指定样本库中随机抽取指定样本，线下开展面访<br />可应用于指定人群面访，指定地点检查等场景'"></div>
              <el-button type="primary" @click="onClickAssignTask">添加指定样本面访</el-button>
              <img class="welcome-img" src="@/assets/img/wj/random-welcome.png" />
            </div>
          </div> -->
          <data-table
            ref="crud"
            cell-class-name="truncate-table-cell-wrap"
            class="data-table"
            :data="tableData"
            :columns="tableOption.column"
            :page="page"
            :showPage="true"
            :loading="tableLoading"
            :selection="true"
            @search-change="onClickSearch"
            @selection-change="selectionChange"
            @pagination-current-change="currentChange"
            @size-change="sizeChange"
            :height="'calc(100vh - 205px)'"
            :span-method="spanMethodProxy"
          >
            <template #status="scope">
              <el-tooltip class="item" effect="light" :content="statusTip(getstatus(scope.row, 'text'))" placement="top">
                <div>
                  <span class="mr-0.5" :style="{ color: getstatus(scope.row, 'color') }">●</span>{{ getstatus(scope.row, 'text') }}
                </div>
              </el-tooltip>
            </template>
            <template #offlineStatus="scope">
              <el-switch :disabled="scope.row.dis" v-model="scope.row.swich" @change="onSwichChange(scope.row, $event)"></el-switch>
            </template>
            <template #opt="scope">
              <el-button type="text" class="" @click="onclickEditShowTask(scope.row)">编辑</el-button>
              <el-button type="text" class="" @click="onCLickShowTask(scope.row)">添加任务</el-button>
              
              <!-- <el-button v-if="scope.row.status == 9" type="text" @click="invate(scope.row)"> 重新邀请 </el-button> -->
            </template>
            <template #settleMethod="scope">
              <span v-if="!scope.row.settleMethod||scope.row.settleMethod === 0">线上结算</span>
              <span v-else-if="scope.row.settleMethod === 1">线下结算</span>
              <span v-else-if="scope.row.settleMethod === 2">无需结算</span>
            </template>
            <template #settleMode="scope">
              <div v-if="scope.row.settleMethod==2">无</div>
              <div v-else class="flex">
                <template>
                  <span v-if="scope.row.settleMode === 1">按答卷数量</span>
                  <span v-if="scope.row.settleMode === 2">按天</span>
                  <span v-if="scope.row.settleMode === 3">按阶梯计价</span>
                </template>
                <template>
                  <span v-if="scope.row.settleRule"
                    >{{ scope.row.settleMode === 1 ? '，回收 ' : '，工作 ' }}{{ scope.row.settleRule ? scope.row.settleRule.expectedQuantity : '' }} {{ scope.row.settleMode === 1 ? ' 份' : ' 天' }}</span
                  >
                  <span v-else>-</span>
                </template>
                <template>
                  <div v-if="scope.row.settleRule">
                    <div v-if="scope.row.settleMode === 1">，每份 {{ scope.row.settleRule.unitPriceYuan }} 元</div>
                    <div v-else-if="scope.row.settleMode === 2">，每天 {{ scope.row.settleRule.unitPriceYuan }} 元</div>
                    <div v-else-if="scope.row.settleMode === 3">
                      <span>
                        ，每天回收 1~{{
                          scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].quantityUpperBound
                        }} 份
                      </span>
                      <span v-if="scope.row.settleRule.tiers.length === 1">
                        ，最高每份 {{ scope.row.settleRule.tiers[0].unitPriceYuan }}元
                      </span>
                      <span v-else>
                        ，最高每份 {{scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan}} 元
                        <!-- {{ scope.row.settleRule.tiers[0].unitPriceYuan }}~{{
                          scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan
                        }}元 -->
                      </span>
                      <el-tooltip placement="top">
                        <div slot="content">
                          <div v-if="scope.row.settleRule.tiers.length > 1">
                            <div v-for="(it, i) in scope.row.settleRule.tiers" :key="i">
                              <p :style="{ marginBottom: i === scope.row.settleRule.tiers.length - 1 ? '0' : '5px' }">
                                <span v-if="i === 0">每天</span>
                                <span v-if="i === 0">1份</span>
                                <span v-else>{{ it.quantityLowerBound + 1 }}份</span>
                                ~
                                <span>{{ it.quantityUpperBound }}</span
                                >份,
                                <span style="margin-left: 3px">{{ it.unitPriceYuan }}元/份</span>
                              </p>
                            </div>
                          </div>
                          <div v-else>
                            <span>每天{{ scope.row.settleRule.tiers[0].unitPriceYuan }}元/份</span>
                          </div>
                        </div>
                        <!-- <i class="iconfont">&#xe63d;</i> -->
                        <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-medium"></i>
                      </el-tooltip>
                    </div>
                    <div v-else>-</div>
                  </div>
                </template>
              </div>

            </template>
            <!-- <template #expectedQuantity="scope">
              <span v-if="scope.row.settleRule"
                >{{ scope.row.settleRule ? scope.row.settleRule.expectedQuantity : ''
                }}{{ scope.row.settleMode === 1 ? '份' : '天' }}</span
              >
            </template> -->
            <!-- <template #unitPriceYuan="scope">
              <div v-if="scope.row.settleRule">
                <div v-if="scope.row.settleMode === 1">{{ scope.row.settleRule.unitPriceYuan }}元/份</div>
                <div v-if="scope.row.settleMode === 2">{{ scope.row.settleRule.unitPriceYuan }}元/天</div>
                <div v-if="scope.row.settleMode === 3">
                  <span v-if="scope.row.settleRule.tiers.length === 1"> {{ scope.row.settleRule.tiers[0].unitPriceYuan }}元/份 </span>
                  <span v-else>
                    {{ scope.row.settleRule.tiers[0].unitPriceYuan }}~{{
                      scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan
                    }}元/份
                  </span>
                  <el-tooltip placement="top">
                    <div slot="content">
                      <div v-if="scope.row.settleRule.tiers.length > 1">
                        <div v-for="(it, i) in scope.row.settleRule.tiers" :key="i">
                          <p :style="{ marginBottom: i === scope.row.settleRule.tiers.length - 1 ? '0' : '5px' }">
                            <span v-if="i === 0">每天</span>
                            <span v-if="i === 0">1份</span>
                            <span v-else>{{ it.quantityLowerBound + 1 }}份</span>
                            ~
                            <span>{{ it.quantityUpperBound }}</span
                            >份,
                            <span style="margin-left: 3px">{{ it.unitPriceYuan }}元/份</span>
                          </p>
                        </div>
                      </div>
                      <div v-else>
                        <span>每天{{ scope.row.settleRule.tiers[0].unitPriceYuan }}元/份</span>
                      </div>
                    </div>
                    <i class="iconfont">&#xe63d;</i>
                  </el-tooltip>
                </div>
              </div>
            </template> -->
            <template slot="page-left">
              <el-button class="mr-3" type="primary" @click="onClickAssignTask">分配任务</el-button>
              <el-popover placement="right" v-model="visible" width="150px">
                <div>
                  <el-button size="mini" type="primary" class="buttonTask buttonTask1" @click="batchOpenTask">批量开启</el-button>
                  <br />
                  <el-button type="primary" class="buttonTask" size="mini" @click="batchCloseTask">批量关闭</el-button>
                </div>
                <el-button slot="reference" @click="editTask">批量开/关任务</el-button>
              </el-popover>
            </template>
          </data-table>

          <el-dialog
            class="theme-dialog"
            title="批量开启任务"
            v-if="taskArr == null ? 0 : taskArr.length"
            :visible.sync="box"
            width="30%"
          >
            <p style="line-height: 20px">
              当前选中<span class="task"> {{ this.taskArr == null ? 0 : this.taskArr.length }} </span
              >个任务，确认全部开启吗？开启后调查员可继续执行任务。
            </p>
            <br />
            <p class="taskTip mb-3">说明：</p>
            <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4 }" placeholder="请输入内容" v-model="batchOCMsg">
            </el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="box = !box">取 消</el-button>
              <el-button type="primary" @click="taskOpenConfirm">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog
            class="theme-dialog"
            title="批量关闭任务"
            v-if="taskArr == null ? 0 : taskArr.length"
            :visible.sync="box1"
            width="30%"
          >
            <p style="line-height: 20px">
              当前选中<span class="task"> {{ this.taskArr == null ? 0 : this.taskArr.length }} </span
              >个任务，确认全部关闭吗？关闭后调查员将不能执行该任务。
            </p>
            <br />
            <p class="taskTip mb-3">说明：</p>
            <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4 }" placeholder="请输入内容" v-model="batchOCMsg">
            </el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="box1 = !box1">取 消</el-button>
              <el-button type="primary" @click="taskCloseConfirm">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog class="theme-dialog" title="批量关闭任务提示！" v-else :visible.sync="box1" width="30%">
            <p>请先勾选对应任务。</p>
            <br />
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="box1 = !box1">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
      <div class="right" :style="{ width: '290px',flex:'none',overflow:'auto', height:'calc(100vh - 128px)' }">
        <Advert :isAssignPage="true"></Advert>
      </div>
    </div>
    <el-drawer
      title="分配任务"
      :visible.sync="exampleTaskDrawer"
      direction="rtl"
      size="80%"
      :destroy-on-close="true"
      :before-close="handleExampleTaskDrawerClose"
    >
      <ExampleTask
        @cancel="handleExampleTaskDrawerClose"
        :len="tableData.length + 1"
        @emitDialog="val => (dialVisible = val)"
      ></ExampleTask>
    </el-drawer>
    <el-drawer
      :title="showTaskTitle"
      :visible.sync="showTaskDrawer"
      direction="rtl"
      :size="1194"
      :destroy-on-close="true"
      :before-close="handleShowTaskDrawerClose"
    >
      <!-- <ShowTask @cancel="handleShowTaskDrawerClose" :rows="curRows" @emitDialog="val => (dialVisible = val)"></ShowTask> -->
      <ShowTask 
        :showTaskRows="showTaskRows"
        showTaskPage="assignSample"
        :showTaskType="showTaskType"
        @cancel="handleShowTaskDrawerClose"
        @callbackClose="ShowTaskEvent"
        :rows="curRows"
        @dialogChange="$emit('changeDialogVisible', true)">
      </ShowTask>
    </el-drawer>
    <el-drawer
      title="结算"
      :visible.sync="settlementTaskDrawer"
      direction="rtl"
      size="60%"
      :destroy-on-close="true"
      :before-close="handleSettlementTaskDrawerClose"
    >
      <SettlementTask @cancel="handleSettlementTaskDrawerClose" @toPay="toPay" :rows="curRows"></SettlementTask>
    </el-drawer>
    <el-drawer
      title="支付"
      :visible.sync="newPayDrawer"
      size="60%"
      :destroy-on-close="true"
      :before-close="handleNewPayDrawerClose"
    >
      <NewPay @cancel="handleNewPayDrawerClose"></NewPay>
    </el-drawer>
    <over-mask
      :dialogVisible="dialVisible"
      @handleClose="
        () => {
          dialVisible = false
        }
      "
    ></over-mask>
    <!-- <AssignSampleTask :visible="AssignSampleTaskVisible" @callbackClose="closeAssignSampleTask"/> -->
    <!-- 同明察暗访拦截弹窗 -->
    <DialogVersion :visible="dialogVersionVisible" type="assign" @close="()=> dialogVersionVisible=false" />
  </div>
</template>

<script>
import { offlineOption } from '@/views/survey/offline/options/index.js'
import { getOfflineSampleList, putOfflineTask, putOfflineTaskSwitch } from '@/api/wenjuan/offline'
import { extendObject } from '@/assets/js/utils'
import DataTable from '@/components/base/DataTable'
import GlobalConfig, { AuthConfig } from '@/global/config'
import ExampleTask from '@/views/survey/offline/components/task/ExampleTask'
import ShowTask from '@/views/survey/cati/components/task/ShowTask'
import SettlementTask from '@/views/survey/offline/components/task/SettlementTask'
import NewPay from '@/views/survey/offline/components/task/NewPay'
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import Advert from '@/components/interview/advert/index.vue'
import AssignSampleTask from '@/views/survey/offline/components/drawer/AssignSampleTask.vue'
import DialogVersion from '@/views/survey/offline/components/dialog/DialogVersion.vue'

import { batchAdd, sinviteAgain } from '@/api/wenjuan/addList'
const statusType = {
  1: {
    type: 'danger',
    text: '待承接',
    color: '#E8A31B',
    off: true,
    dis: false
  },
  11:{
    type: 'info',
    text: '已承接',
    color: '#00be6a',
    off: true,
    dis: false
  },
  12:{
    type: 'info',
    text: '已拒接',
    color: 'rgba(0, 0, 0, 0.15)',
    off: true,
    dis: false
  },
  0: {
    type: 'danger',
    text: '已分配',
    color: '#00BE6A',
    off: true,
    dis: false
  },
  6: {
    type: 'danger',
    text: '已分配',
    color: '#00BE6A',
    off: true,
    dis: false
  },
  7: {
    type: 'success',
    text: '已关闭',
    color: 'rgba(0, 0, 0, 0.15)',
    off: false,
    dis: false
  },
  8: {
    type: 'info',
    text: '已结算',
    color: '#E34152',
    off: false,
    dis: true
  },
  9: {
    type: 'info',
    text: '邀请中',
    color: '#E8A31B',
    off: true,
    dis: false
  },
  10: {
    type: 'info',
    text: '已邀请',
    color: '#2775E8',
    off: true,
    dis: false
  },
  
}
export default {
  name: 'offline',
  components: {
    DataTable,
    ExampleTask,
    ShowTask,
    SettlementTask,
    NewPay,
    OverMask,
    Advert,
    AssignSampleTask,
    DialogVersion
  },
  provide(){
    return {
      addSampleType: 'offline'
    }
  },
  data() {
    return {
      dialogVersionVisible:false,
      // 调查员id
      investigatorId: 0,
      curRows: {},
      showTaskDrawer: false,
      exampleTaskDrawer: false,
      settlementTaskDrawer: false,
      newPayDrawer: false,
      emptyShow: true,
      tableDataLen: '', // ''控制初始化
      tableData: [],
      tableLoading: false,
      tableOption: offlineOption,
      visible: false,
      box: false,
      box1: false,
      batchOCMsg: '',
      taskArr: {
        // id:[],
        // length:''
      },
      type: [],
      SearchPhoneValue: '', // 手机号筛选
      SearchStatusValue: '', // 状态筛选
      executorName: '', // 调查员姓名
      executionName: '', // 任务名称
      statusList: [
        {
          value: "1",
          label: "待承接"
        },
        {
          value: "2",
          label: "已承接"
        },
        {
          value: '6',
          label: '已分配'
        },
        {
          value: '7',
          label: '已关闭'
        },
        {
          value: '8',
          label: '已结算'
        },
        {
          value: '9',
          label: '邀请中'
        },
        {
          value: '10',
          label: '已邀请'
        },
        {
          value: "12",
          label: "已拒接"
        },
      ],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        pageSizes: [5, 10, 20, 30, 50, 100]
      },
      formInline: {},
      guideDialog: false,
      dialogData: [
        { title: '步骤一： 添加调查员', content: '面对面访问由调查员执行，请先添加调查员，告知调查员下载安装面访APP' },
        {
          title: '步骤二：进行面访设置',
          content: '设置面访质控的多媒体素材，可在调查员录入答卷时开启强制录音、前后置摄像头录像，用于答卷审核'
        },
        {
          title: '步骤三：分配面访任务',
          content: '选择调查员分配面访任务，包含截止时间、答卷数量和单价，完成后调研任务将下发到具体调查员面访APP的任务列表'
        },
        { title: '步骤四：线下面访', content: '调查员接到调研任务后，现场调研并通过面访APP记录上传调研答卷' },
        { title: '步骤五：审核答卷', content: '审核员对回收答卷进行审核，支持只审核重点问题，一键审核通过和设置多级审核' },
        { title: '步骤六：佣金结算', content: '面访任务完成后，管理员可在线结算调查员佣金，调查员可通过面访APP进行提现' }
      ],
      dialVisible: false,
      AssignSampleTaskVisible: false,
      showTaskTitle:'',
      showTaskType: '',
      showTaskRows:[],
      propsWelcomeShow: false,
    }
  },
  watch: {},
  methods: {
    toSearch() {
      this.page.currentPage = 1
      this.getList()
    },
    onReset() {
      this.SearchPhoneValue = ''
      this.SearchStatusValue = ''
      this.executorName = '';
      this.executionName = '';
      
      this.toSearch()
    },
    // changePhoneValue(e){
    //   // console.log(e.target.value);
    //   this.SearchPhoneValue = e.target.value
    //   this.page.currentPage = 1
    //   this.getList()
    // },
    batchOpenTask() {
      if (this.taskArr == null || this.taskArr.length <= 0) {
        this.$message.error('请勾选需要批量处理的任务')
      } else {
        this.box = true
      }
    },
    batchCloseTask() {
      if (this.taskArr == null || this.taskArr.length <= 0) {
        this.$message.error('请勾选需要批量处理的任务')
      } else {
        this.box1 = true
      }
    },
    taskOpenConfirm() {
      const id = this.taskArr.map(item => {
        return item.id
      })
      const p = {
        idList: id,
        explanation: this.batchOCMsg,
        batchFlag: 1
      }
      batchAdd(p)
        .then(res => {
          this.onRefreshList()
          this.box = !this.box
        })
        .catch(err => {
          console.log(err)
        })
      this.batchOCMsg = ''
    },
    taskCloseConfirm() {
      const id = this.taskArr.map(item => {
        return item.id
      })
      const p = {
        idList: id,
        explanation: this.batchOCMsg,
        batchFlag: 0
      }
      batchAdd(p)
        .then(res => {
          this.onRefreshList()
          this.box1 = !this.box1
        })
        .catch(err => {
          console.log(err)
        })
      this.batchOCMsg = ''
    },
    onSwichChange(row, batchFlag) {
      batchFlag = batchFlag ? 1 : 0
      putOfflineTaskSwitch({ idList: [row.id], batchFlag, explanation: '' }).then(res => {
        // console.log(res);
        // row.status = status
        this.getList()
      })
    },
    // 分配任务
    onClickAssignTask() {
      // this.exampleTaskDrawer = true
      // this.AssignSampleTaskVisible = true;
      if(![AuthConfig.TeamBase, AuthConfig.TeamPlus].includes(GlobalConfig.getAuthCode())){
        this.dialogVersionVisible = true
      }else{
        this.exampleTaskDrawer = true
      }
    },
    handleExampleTaskDrawerClose() {
      this.exampleTaskDrawer = false
      this.getList()
    },
    handleSettlementTaskDrawerClose() {
      this.settlementTaskDrawer = false
      this.getList()
    },
    handleNewPayDrawerClose() {
      this.newPayDrawer = true
      this.getList()
    },
    toPay() {
      this.settlementTaskDrawer = false
      this.newPayDrawer = true
    },
    onClickSearch() {},
    onCLickSettlement(row) {
      let rows = JSON.parse(JSON.stringify(row))
      rows.offlineId = rows.id
      delete rows.id
      let query = {}
      extendObject(query, rows)
      console.log(rows)
      this.curRows = rows
      this.settlementTaskDrawer = true
      // this.$router.push({
      //   path: `/survey/${GlobalConfig.getSurveyId()}/offline/assign-sample-interview/settlement-task`,
      //   query
      // })
    },
    //
    ShowTaskEvent(val,type){
      this.showTaskDrawer = val;
      if(type){
        this.getList()
      }
    },
    // 编辑任务
    onclickEditShowTask(row){
      this.showTaskTitle = '编辑任务';
      this.curRows = JSON.parse(JSON.stringify(row));
      this.showTaskType = 'edit';
      this.showTaskDrawer = true;
    },
    // 添加任务
    onCLickShowTask(row) {
      this.showTaskTitle = '添加任务';
      this.curRows = JSON.parse(JSON.stringify(row));
      this.showTaskType = 'add';
      this.showTaskDrawer = true;
      
    },
    handleShowTaskDrawerClose() {
      this.showTaskDrawer = false
      this.getList()
    },
    // 重新邀请
    invate(v) {
      console.log(v)
      sinviteAgain(v.id)
        .then(res => {
          console.log(res)
          this.$message.success(res.data.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getstatus(row, info) {
      return statusType[row.status][info]
    },
    statusTip(r) {
      if (r == '已分配') {
        return '成功分配的任务'
      } else if (r == '已关闭') {
        return '调查员不能继续执行的任务'
      } else if (r == '已结算') {
        return '已结算完佣金的任务'
      } else if (r == '邀请中') {
        return '未注册手机号，创建任务成功，没有收到短信发送成功通知的任务'
      } else if (r == '已邀请') {
        return '未注册手机号，创建任务成功，且收到短信发送成功通知的任务'
      }
    },
    // onLoadList() {
    //   this.onRefreshList()
    // },
    onRefreshList() {
      this.tableLoading = true
      // 查询任务列表
      const p = {
        size: this.page.pageSize,
        current: this.page.currentPage
      }
      this.getList()
    },
    // 处理tableList数据 添加rowspan
    handleTableData(dataList) {
      // 需要去重的数组
      let repeatField = []
      dataList.forEach(item => {
        repeatField.push(item.executorPhone)
      })
      repeatField = [...new Set(repeatField)]
      dataList.forEach((it, i, arr) => {
        repeatField.forEach(itField => {
          if (itField === it.executorPhone) {
            it.rowspan = arr.filter(itemFilter => itemFilter.executorPhone === itField).length
          }
        })
      })
      console.log(dataList)
    },
    // 获取 list
    getList() {
      const params = {
        surveyId: GlobalConfig.getSurveyId(),
        id: this.investigatorId !== 0 ? this.investigatorId : null,
        size: this.page.pageSize,
        current: this.page.currentPage
      }
      if (this.SearchPhoneValue) {
        params.executorPhone = this.SearchPhoneValue
      }
      if (this.SearchStatusValue != '') {
        params.status = this.SearchStatusValue
      }
      if (this.executorName != '') {
        params.executorName = this.executorName
      }
      if (this.executionName != '') {
        params.executionName = this.executionName
      }
      this.propsWelcomeShow = false;
      return getOfflineSampleList(params)
        .then(res => {
          // console.log(res);
          this.page.total = res.data.data.total;
          this.propsWelcomeShow = res.data.data.records.length == 0 ? true : false
          this.tableData = res.data.data.records.map(data => {
            data.swich = statusType[data.status].off
            data.dis = statusType[data.status].dis
            return data
          })
          this.handleTableData(this.tableData);
          if (this.page.total > 0) {
            this.emptyShow = false
          }
          this.tableLoading = false
        })
        .catch(err => {
          this.tableLoading = false
        })
    },
    sizeChange(val) {
      this.page.pageSize = val
      this.getList()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
    editTask() {
      console.log('点击了批量操作')
    },
    selectionChange(row) {
      
      const ids = row
      .map(it => ({ executorPhone: it.executorPhone }))
      .map(it => Object.values(it))
      .flat()
      const filterObj = this.tableData.filter(it => ids.includes(it.executorPhone))
      console.log('filterObj',filterObj)
      this.taskArr = filterObj;
      // this.taskArr = row.map(item => {
      //   return item
      // })
    },
    // 关闭新版分配任务弹窗
    closeAssignSampleTask(val){
      console.log('val',val)
      this.AssignSampleTaskVisible = val;
    },
    // 委托代理表格合并
    spanMethodProxy({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        if (row.rowspan) {
          if (this.tableData[rowIndex - 1] === undefined) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            }
          } else if (
            // row.executorName !== this.tableData[rowIndex - 1].executorName ||
            row.executorPhone !== this.tableData[rowIndex - 1].executorPhone
          ) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.investigatorId = Number(this.$route.query.id)
    }
    // 获取展示状态信息
    this.tableLoading = true
    this.getList().then(() => {
      this.guideDialog = this.tableData.length === 0
      this.emptyShow = this.tableData.length === 0
    })
    //初始化taskArr
    this.taskArr = null
  }
}
</script>
<style lang="scss" scoped>
.no-question-component {
  // position: fixed;

  align-items: center;
  .text-tip {
    text-align: center;
    @apply text-theme-black-650 text-medium;
  }

  .add-question-btn {
    margin-top: 20px;
    text-align: center;
  }
}
</style>

<style scoped lang="scss">
.table-crud {
  // 解决固定列挡住 空数据时的按钮 点击问题；点击穿透
  ::v-deep .el-table__fixed,
  ::v-deep .el-table__fixed-right {
    pointer-events: none !important;
    .cell {
      pointer-events: auto;
      &:hover {
        color: #227ffe;
      }
    }
  }
}
.buttonTask {
  width: 150px;
}
::v-deep .buttonTask.el-button--primary {
  background-color: #4e99fe;
  border-color: #4e99fe;
}
::v-deep .buttonTask.el-button--primary:hover,
.el-button--primary:focus {
  background: #227ffe;
  border-color: #227ffe;
}
.buttonTask1 {
  margin-bottom: 5px;
}
.task {
  color: rgb(217, 0, 27);
  font-size: 20px;
  font-weight: bold;
}
.taskTip {
  font-size: 18px;
  font-weight: bold;
}
.inputStyle {
  width: 200px;
  margin-left: 188px;
  top: 2px;
}
.optionStyle {
  position: absolute;
  width: 100px !important;
  margin-left: 10px;
  top: 2px;
}
.el-form {
  .el-input {
    width: 200px;
  }

  ::v-deep .el-form-item__content {
    width: 200px;
  }

  .el-date-picker {
    width: 200px !important;
  }
}
.item {
  cursor: pointer;
}
.promptDialog {
  width: 100%;
  height: 70vh;
  h1 {
    text-align: center;
    color: #000;
    margin: 0;
  }
  .content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .items {
      width: 25%;
      height: 120px;
      box-shadow: 0px 0px 5px 2px #eee;
      margin: 20px 2.1%;
      padding: 2%;
      border-radius: 5px;
      h3 {
        color: #000;
        font-size: 18px;
      }
      p {
        color: rgb(141, 141, 141);
        font-size: 16px;
        margin-top: 10px;
        font-weight: 500;
      }
    }
  }
}
</style>
